function binaryToArrayBuffer(binary: string): ArrayBuffer {
    // New ArrayBuffer
    const arrayBuffer = new ArrayBuffer(binary.length);

    // New Uint8Array
    const uint = new Uint8Array(arrayBuffer);

    // Foreach Binary
    for (let i = 0; i < binary.length; i++) {
        uint[i] = binary.charCodeAt(i);
    }

    // Return
    return arrayBuffer;
}

// ----------------------------------------------------------------------------

export default binaryToArrayBuffer;
